module.exports = __webpack_public_path__ + "static/img/game-pic1.6b1fcc80.png";